<template>
  <div
    v-loading="loadingAllDataRequired"
    element-loading-text="Cargando..."
    element-loading-background="rgba(255, 255, 255)"
  >
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tareas')">
        <div class="content">
          <CompShowPage
            v-if="contract && inventory && Object.keys(inventory).length > 0"
            :workflows="workflows"
            :inventory="inventory"
            :contractPeople="contractPeople"
            :contract="contract"
          />
          <div
            v-if="contract !== null && inventory !== null && Object.keys(inventory).length === 0"
            class="red no-inventory"
          >
            {{ $t('Inventario de Riesgos') }}
            <b>{{ $t('NO INICIADO') }}</b>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="paddingBody" :label="$t('Contrato')">
        <MostrarContrato v-if="contract" :contract="contract" />
      </el-tab-pane>
      <el-tab-pane class="paddingBody" :label="$t('Vista Inventario')">
        <el-table
          :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
          border
          stripe
          :data="viewTableInventory"
          style="width: 100%;"
          height="800"
        >
          <el-table-column label="Paso del Proceso">
            <template slot-scope="scope">{{scope.row.tarea || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evento Top">
            <template slot-scope="scope">{{scope.row.evento_top || "---"}}</template>
          </el-table-column>
          <el-table-column label="Peligro">
            <template slot-scope="scope">{{scope.row.peligro || "---"}}</template>
          </el-table-column>
          <el-table-column label="Energía">
            <template slot-scope="scope">{{scope.row.energia || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evento no deseado">
            <template slot-scope="scope">{{scope.row.evento_no_deseado || "---"}}</template>
          </el-table-column>
          <el-table-column label="Nivel de riesgo Sin Control" align="center">
            <template slot-scope="scope">{{scope.row.nivel_riesgo_sin_control || "---"}}</template>
          </el-table-column>
          <el-table-column label="Controles existentes">
            <template slot-scope="scope">{{scope.row.controles || "---"}}</template>
          </el-table-column>
          <el-table-column label="Jerarquía de Control">
            <template slot-scope="scope">{{scope.row.jerarquia_control || "---"}}</template>
          </el-table-column>
          <el-table-column label="Evaluación con controles" align="center">
            <el-table-column label="Probabilidad" align="center">
              <template slot-scope="scope">{{scope.row.probabilidad || "---"}}</template>
            </el-table-column>
            <el-table-column label="Consecuencia" align="center">
              <template slot-scope="scope">{{scope.row.consecuencia || "---"}}</template>
            </el-table-column>
            <el-table-column label="Clasificación del Riesgo">
              <template slot-scope="scope">{{scope.row.tipo || "---"}}</template>
            </el-table-column>
            <el-table-column label="Controles Adicionales">
              <template slot-scope="scope">{{scope.row.control_adicional || "---"}}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Administración" align="center">
            <el-table-column label="Responsable de Verificar los Controles">
              <template slot-scope="scope">{{scope.row.responsable_control || "---"}}</template>
            </el-table-column>
            <el-table-column label="Frecuencia">
              <template slot-scope="scope">{{scope.row.frecuencia || "---"}}</template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import CompShowPage from "@/components/C_ShowPage.vue";
import MostrarContrato from "@/components/MostrarContrato.vue";

export default {
  mixins: [inventoryRequirements],
  components: {
    CompShowPage,
    MostrarContrato
  },
  data() {
    return {
      viewTableInventory: [],
      auxStatus: {
        0: { text: "Borrador", colorClass: "gray" },
        1: { text: "Revisión", colorClass: "yellow" },
        2: { text: "Aprobado", colorClass: "green" },
        3: { text: "Importado Borrador", colorClass: "gray" }
      }
    };
  },
  created() {
    // Títulos
    this.setTitle(this.$t("Inventario de riesgos"));
  },
  watch: {
    inventory: function(newVal, oldVal) {
      this.tableInventory();
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.$t("Contrato")}: ${this.contract.nombre}`);
        }
      }
    }
  },
  methods: {
    ...mapActions(["setTitle", "setSubTitle"]),
    tableInventory() {
      this.viewTableInventory = [];
      this.inventory.tareas.forEach(t => {
        if (t.riesgos) {
          t.riesgos.forEach(r => {
            if (r.causas && r.causas.length > 0) {
              r.causas.forEach(causa => {
                if (
                  causa.controles_preventivos &&
                  causa.controles_preventivos.length > 0
                ) {
                  causa.controles_preventivos.forEach(cp => {
                    this.viewTableInventory.push({
                      id: t._id,
                      tarea: t.nombre,
                      evento_top: r.nombre,
                      peligro: r.peligro ? r.peligro : "",
                      energia: r.energia ? r.energia : "",
                      evento_no_deseado: r.evento_no_deseado
                        ? r.evento_no_deseado
                        : "",
                      nivel_riesgo_sin_control: r.sin_controles
                        ? r.sin_controles.severidad
                        : "",
                      controles: cp.nombre,
                      jerarquia_control: cp.jerarquiaControl,
                      probabilidad: r.con_controles
                        ? r.con_controles.probabilidad
                        : "",
                      consecuencia: r.con_controles
                        ? r.con_controles.severidad
                        : "",
                      tipo: r.tipo,
                      control_adicional: r.control_adicional,
                      responsable_control: cp.responsable,
                      frecuencia: cp.frecuencia
                    });
                  });
                }
              });
            } else {
              this.viewTableInventory.push({
                id: t._id,
                tarea: t.nombre,
                evento_top: r.nombre,
                peligro: r.peligro ? r.peligro : "",
                energia: r.energia ? r.energia : "",
                evento_no_deseado: r.evento_no_deseado
                  ? r.evento_no_deseado
                  : "",
                nivel_riesgo_sin_control: r.sin_controles
                  ? r.sin_controles.severidad
                  : "",
                controles: "",
                jerarquia_control: "",
                probabilidad: r.con_controles
                  ? r.con_controles.probabilidad
                  : "",
                consecuencia: r.con_controles ? r.con_controles.severidad : "",
                tipo: r.tipo,
                control_adicional: r.control_adicional,
                responsable_control: "",
                frecuencia: ""
              });
            }
          });
        } else {
          this.viewTableInventory.push({
            id: t._id,
            tarea: t.nombre,
            evento_top: "",
            peligro: "",
            energia: "",
            evento_no_deseado: "",
            nivel_riesgo_sin_control: "",
            controles: "",
            jerarquia_control: "",
            probabilidad: "",
            consecuencia: "",
            tipo: "",
            control_adicional: "",
            responsable_control: "",
            frecuencia: ""
          });
        }
      });
    },
    goBack() {
      window.history.go(-1);
    },
    isActiveContract() {
      if (this.contract.tipo_contrato == "Propio") return true;
      return moment(this.contract.fecha_fin) - new Date() >= 0;
    },
    inventoryStatusText() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].text
        : "No Iniciado";
    },
    inventoryStatusColor() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].colorClass
        : "gray";
    }
  }
};
</script>

<style scoped>
.content {
  min-height: 50vh;
}
.no-inventory {
  padding: 20px;
  color: #ffffff;
  text-align: center;
}
</style>
